import BodyText from "./BodyText";
import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import { formatPrice } from "../core/utils";
import HeadingMedium from "./HeadingMedium";

function ItemPriceComparison({ data }) {
  return (
    <Box>
      <BodyText
        fontWeight={700}
        lineHeight={[1, null, null, null]}
        color="#9E9E9E"
        mb={[10, 10, 10, 10]}
      >
        <s>{formatPrice(data.brandRrp)}</s>
      </BodyText>
      <HeadingMedium as="h3">{formatPrice(data.price)}</HeadingMedium>
      <BodyText
        fontWeight={700}
        lineHeight={[1, null, null, null]}
        color="green"
        uppercase
        mt={[10, 10, 10, 10]}
      >
        Save {formatPrice(data.moneySaving)} ({data.percentageSaving}% off)
      </BodyText>
    </Box>
  );
}

export default ItemPriceComparison;

ItemPriceComparison.propTypes = {
  data: PropTypes.shape({
    price: PropTypes.string.number,
    brandRrp: PropTypes.string.number,
    moneySaving: PropTypes.string.number,
    percentageSaving: PropTypes.string.number,
  }).isRequired,
};
